export default "__VITE_ASSET__Dwu6qhKJ__"